import { render, staticRenderFns } from "./MarkDown.vue?vue&type=template&id=c4977be0&"
import script from "./MarkDown.vue?vue&type=script&lang=ts&"
export * from "./MarkDown.vue?vue&type=script&lang=ts&"
import style0 from "./MarkDown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports